import { render, staticRenderFns } from "./MyBenefitRequest.vue?vue&type=template&id=31a5fdfc&scoped=true"
import script from "./MyBenefitRequest.vue?vue&type=script&lang=js"
export * from "./MyBenefitRequest.vue?vue&type=script&lang=js"
import style0 from "./MyBenefitRequest.vue?vue&type=style&index=0&id=31a5fdfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a5fdfc",
  null
  
)

export default component.exports